module.exports = __webpack_public_path__ + "static/media/admin-bank-terminal.c2f5736b.svg";